const origin = window.location.origin;
export const baseUrl = `${
  origin.includes("sheprd.test") || origin.includes("dev.sheprd")
    ? "https://dev.sheprd.app"
    : origin
}/api`;

export const baseTitle = "Sheprd | {{company}}";
export const imageExtensions = [".jpg", ".png", ".webp", ".gif", ".svg"];
export const videoExtensions = [
  ".mp4",
  ".mov",
  ".wmv",
  ".webm",
  ".avi",
  "flv",
  "mkv",
  "mts",
];

export const editableExtensions = [".jpg", ".png"];

export const defaultColors = {
  companyColor: "#000000",
  companyText: "#000000",
  companyLine: "#181818",
  companyBtn: "#121212",
  companyIconFade: "#565656",
  companyBtnHover: "#2d2d2d",
  overlayBtn: "#40403f",
  overlayBtnDisabled: "#1f1f1f",
  subTextColorOnCompanyColor: "#8c8c8c",
  lightGrayBtn: "#a9a9a9",
  lightGrayBtnBorder: "#e8e8e8",
  lightBtn: "#f0f0f0",
  lightBtnHover: "#e2e2e2",
  lightBtnBorder: "#e8e8e8",
  lightBtnDisabled: "#f4f4f4",
};
